// extracted by mini-css-extract-plugin
export default {"cls1":"Qo0kvHONvHyFnFXlfvpE","cls2":"zqSQ1QaPwXnXdhA1C5tm Qo0kvHONvHyFnFXlfvpE"};